<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-row>
      <v-col cols="12" class="text-center mb-8">
        <v-badge :value="!!pictureUrl" overlap offset-x="-20" offset-y="-20">
          <template v-slot:badge>
            <v-icon small @click="removePicture">mdi-delete</v-icon>
          </template>

          <label for="upload" style="width: 130px; height: 130px">
            <v-btn icon :disabled="isMember" @click="onButtonClick">
              <input
                ref="uploader"
                type="file"
                id="upload"
                accept="image/*"
                class="d-none"
                @change="handleFileUpload"
                :disabled="isMember"
              />
              <v-avatar
                size="130"
                :tile="true"
                v-if="pictureUrl"
                style="background-color: #e0e0e0; text-align: center"
              >
                <img :src="pictureUrl" alt="" />
              </v-avatar>
              <v-sheet
                width="130"
                height="130"
                outlined
                tile
                class="d-flex align-center justify-center"
                v-else
              >
                <v-icon large>mdi-camera-plus</v-icon>
              </v-sheet>
            </v-btn>
          </label>
        </v-badge>
      </v-col>

      <v-col cols="12">
        <v-text-field
          outlined
          v-model="form.name"
          :label="$t('business_name')"
          :rules="[rules.required($t('business_name'))]"
          :disabled="isMember"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12">
        <v-select
          outlined
          v-model="form.channel_business_type"
          :label="$t('business_type')"
          :items="businessTypeOptions"
          item-text="label"
          item-value="value"
          :rules="[rules.required($t('business_type'))]"
          :disabled="isMember"
          hide-details
          dense
        />
      </v-col>

      <v-col cols="12" v-if="form.channel_business_type === '0'">
        <v-text-field
          outlined
          v-model="form.other_business_type"
          :label="$t('please_specify')"
          :rules="[rules.required($t('business_other_type'))]"
          :disabled="isMember"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6">
        <v-btn
          block
          outlined
          @click="setShowDialog(false)"
          style="border-radius: 38px 38px 0px 38px !important"
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-col>

      <v-col cols="6">
        <v-btn
          block
          color="primary"
          :loading="isSubmitting"
          :disabled="isMember || isSubmitting"
          type="submit"
          class="btn-custom"
        >
          {{ $t('save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import imageSetting from '../../mixins/imageSetting'
export default {
  props: {
    profileToEdit: Object,
    createProfile: Function,
    editProfile: Function,
    setShowDialog: Function
  },
  data() {
    return {
      form: {
        name: this.profileToEdit.name || '',
        channel_business_type:
          this.profileToEdit.channel_business_type?.id?.toString() || '',
        other_business_type: this.profileToEdit.other_business_type || '',
        id: this.profileToEdit.id || ''
      },
      pictureUrl: this.profileToEdit.picture_url || '',
      isSubmitting: false,
      businessTypeOptions: []
    }
  },
  computed: {
    isMember() {
      return this.profileToEdit.channel_member_role?.name === 'MEMBER'
    },
    rules() {
      return {
        required: (field) => (v) => !!v || this.$t('form.required', { field })
      }
    }
  },
  methods: {
    async fetchBusinessTypes() {
      try {
        const res = await this.$store.dispatch('ssoAccount/getBusinessType')
        if (res?.status === 200 && Array.isArray(res.data)) {
          const [first, ...rest] = res.data
          this.businessTypeOptions = [...rest, first].map((item) => ({
            label: this.$i18n.locale === 'en' ? item.label_en : item.label_th,
            value: String(item.value),
            id: item.id
          }))
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleFileUpload(e) {
      try {
        const file = e.target.files[0]
        if (!file) return
        const image = await imageSetting.methods.upload(file, Date.now())
        this.pictureUrl = image || ''
        e.target.value = null
      } catch (err) {
        console.error(err)
      }
    },
    onButtonClick() {
      window.addEventListener('focus', () => {}, { once: true })

      this.$refs.uploader.click()
    },
    removePicture() {
      this.$refs.uploader.value = null
      this.pictureUrl = ''
    },
    async onSubmit() {
      if (!this.$refs.form.validate()) return

      this.isSubmitting = true

      const selectedType = this.businessTypeOptions.find(
        (t) => t.value === this.form.channel_business_type
      ) || { id: 0, label: '' }

      const payload = {
        ...this.form,
        picture_url: this.pictureUrl,
        channel_business_type: {
          id: parseInt(selectedType.value),
          name: selectedType.label
        }
      }

      try {
        if (!payload.id) {
          await this.createProfile(payload)
        } else {
          await this.editProfile(payload)
        }
        this.setShowDialog(false)
      } catch (err) {
        console.error(err)
      } finally {
        this.isSubmitting = false
      }
    }
  },
  mounted() {
    this.fetchBusinessTypes()
  }
}
</script>
